/**
 *
 * @param publicID
 */
export function isFileName(publicID) {
    return publicID.indexOf('/') < 0;
}
